import { Box, useTheme } from "@mui/material";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Text from "../../theme/text/Text";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import Subheading from "../../theme/text/Subheading";

const MHasDocumentsModal = ({ open, handleClose, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return (
        <SHModal
            open={open}
            onClose={handleClose}
            title={t("select_label")}
            sx={{
                body: {
                    minWidth: 400,
                    maxWidth: 500
                }
            }}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    alignItems:'center',
                    gap:1
                }}>
                <Subheading>{t("extra_documents_title")}</Subheading>
            </Box>
            <Box 
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2,
                    pb:1,

                }}
            >
                <Text center>{t("extra_documents_description")}</Text>

            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "24px",
                    display:"flex",
                    alignItems:"center",
                    px:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton 
                    className={"group-btn"} 
                    color={"red"}
                    variant="contained" 
                    onClick={handleClose}
                >
                    {t("got_it")}
                </Shbutton>
            </Box>
        </SHModal>
    );
};

export default MHasDocumentsModal;